<template>
  <div>
    <Head title="Termin bearbeiten" />
    <h1 class="flex items-center mb-8 text-orfBlue-100 text-3xl font-bold">
      <HeroIcon name="rectangle-stack" class="mr-2 w-10 h-10 fill-orfBlue-100" />
      <Link class="text-orfBlue-400 hover:text-orfBlue-600" href="/events">Termine</Link>
      <span class="mx-2 text-orfBlue-400 font-medium">/</span>
      <div>{{ formatDateTime(form.start, 'LL') }}</div>
    </h1>
    <div class="max-w-2xl bg-white rounded-md shadow">
      <form @submit.prevent="update" class="flex flex-col items-center">
        <div class="relative flex flex-col flex-wrap justify-between -mb-8 -mr-6 p-8 w-full md:flex-row">
          <div class="flex flex-col md:w-full">
            <select-input v-model="form.type" :pre="form.type ? form.type : 'homeoffice'" min-w row :error="form.errors.type" class="my-2 w-full w-40 flex items-center justify-between" label="Art">
              <option hidden value="homeoffice">Homeoffice</option>
              <option value="büro">Büro</option>
              <option value="urlaub">Urlaub</option>
            </select-input>
            <div v-if="form.type == 'urlaub'" class="flex items-center justify-between w-full flex-wrap">
              <div class="hidden sm:flex">
                Datum:
              </div>
              <div class="flex flex-wrap my-2">
                <DatePicker class="flex flex-wrap" locale="de" mode="date" :popover="{ visibility: 'focus', placement: 'left' }" v-model="form.start" is24hr :minute-increment="15">
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="w-full">
                      <div class="flex items-center justify-between">
                        <label class="form-label flex-grow mb-0" for="start">Von</label>
                        <input id="start" class="form-input ml-2 w-28" :value="inputValue" v-on="inputEvents" />
                      </div>
                      <div v-if="form.errors.start" class="form-error">{{ form.error.start }}</div>
                    </div>
                  </template>
                </DatePicker>
                <DatePicker class="flex flex-wrap ml-2" locale="de" mode="date" :popover="{ visibility: 'focus', placement: 'left' }" v-model="form.end" is24hr :minute-increment="15">
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="w-full">
                      <div class="flex items-center justify-between">
                        <label class="form-label flex-grow mb-0" for="end">Bis</label>
                        <input id="end" class="form-input ml-2 w-28" :value="inputValue" v-on="inputEvents" />
                      </div>
                      <div v-if="form.errors.end" class="form-error">{{ form.errors.end }}</div>
                    </div>
                  </template>
                </DatePicker>
              </div>
            </div>
            <DatePicker v-if="form.type != 'urlaub'" locale="de" mode="date" v-model="form.start" class="custom-picker relative flex flex-wrap my-2">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="form-label flex-grow mb-0" for="start">Datum</label>
                    <input id="start" class="form-input ml-2 w-36" :value="inputValue" v-on="inputEvents" />
                  </div>
                  <div v-if="form.errors.start" class="form-error">{{ form.error.start }}</div>
                </div>
              </template>
            </DatePicker>
<!--            <div class="relative flex flex-row flex-wrap items-start justify-between my-2 w-full">
              <label v-if="form.description" class="absolute z-50 -top-2 left-2 px-0.5 w-auto text-xs bg-white" for="description">Beschreibung</label>
              <textarea-input v-model="form.description" id="description" :error="form.errors.description" class="flex-grow" placeholder="Beschreibung (optional)" />
            </div>-->
          </div>
          <div v-for="errors in form.errors">{{ errors }}</div>
        </div>
        <div class="flex flex-col-reverse sm:flex-row items-center mt-4 px-8 justify-between gap-4 py-4 w-full bg-gray-50 border-t border-gray-100">
          <loading-button v-if="!event.deleted_at" small text="Termin löschen" func="delete" inverted icon-name="trash" icon-mini @click.prevent="destroy"/>
          <loading-button :loading="form.processing" text="Termin aktualisieren" class="" icon-name="save" icon-custom-icon/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import moment from 'moment'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
    SelectInput,
    Head,
    HeroIcon,
    Link,
    LoadingButton,
    TextareaInput,
  },
  layout: Layout,
  props: {
    event: Object,
    is_admin: Boolean,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        start: this.event.start,
        end: this.event.end,
        description: this.event.description,
        type: this.event.type,
      }),
    }
  },
  methods: {
    formatDateTime: function (date, format) {
      return moment(date).format(format)
    },
    update() {
      this.form.start = new Date(this.form.start).setHours(0)
      this.form.end = new Date(this.form.end).setHours(0)
      this.form.put(`/events/${this.event.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this event?')) {
        this.$inertia.delete(`/events/${this.event.id}`)
      }
    },
  },
}
</script>

<style>
.custom-picker.vc-container {
  position: absolute;
}
</style>
